import {useFormikContext} from 'formik';
import CustomComponent from '../components/CustomComponent';
import {HO_SO_BENH_AN_FORM} from '../../../../../../constants/BenhAn';
import {useDetailHoSoBenhAn, useMedicalRecordFormIO} from '../../../../../../modals/modal-benh-an/hooks/hoSoBenhAn';
import {OctGenerateForm} from '@oceantech/oceantech-ui';
import {useEffect} from 'react';
import {usePhanHeKhamBenhContext} from "../../../../../../contexts/PhanHeTiepDonContext";

const TongKetBenhAn = (props: any) => {
  const {setFieldValue, values} = useFormikContext<any>();
  const {benhNhanInfo} = usePhanHeKhamBenhContext();

  const benhNhanDieuTri = benhNhanInfo?.thongTinKhamBenh || {}

  const {formJSON} = useMedicalRecordFormIO({
    medicalRecordCode: props.medicalRecordTypeCode,
    formCode: HO_SO_BENH_AN_FORM.TRANG_TONG_KET,
  });
  const {data} = useDetailHoSoBenhAn({
    medicalRecordId: benhNhanDieuTri?.encounterIdExec,
    formName: HO_SO_BENH_AN_FORM.TRANG_TONG_KET,
  });

  useEffect(() => {
    if (data) {
      setFieldValue('forms', data);
    }
  }, [data]);

  return (
    <OctGenerateForm
      listFieldAuto={formJSON}
      modelID="forms"
      values={values}
      setFieldValue={setFieldValue}
      customComponent={CustomComponent}
    />
  );
};

export default TongKetBenhAn;
